import React from "react";
import styled from "styled-components";
import { Modal, Card, Checkbox, Button } from "antd";
import { withTranslation } from "react-i18next";
import { compose } from "recompose";

import university from "../../assets/img-institucion.svg";
import partner from "../../assets/img-partner.svg";

const Title = styled.h2`
  text-align: center;
  color: #343a40;
  font-size: 20px;
  margin-bottom: 0;
`;

const Wrapper = styled.div`
  margin-top: 24px;
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

const CheckboxOverRide = styled(Checkbox)`
  && {
    margin-top: 24px;
    .ant-checkbox-inner {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      &:after {
        display: none;
      }
    }
  }
`;

const ButtonSend = styled.div`
  max-width: 300px;
  width: 100%;
  display: flex;
  margin: auto;
  margin-top: 24px;
`;

const { Meta } = Card;

const UniversityOrCompanyModal = ({ history, t }) => {
  const [state, setState] = React.useState(0);
  const onChange = (e, current) => setState(e.target.checked && current);
  const title = !state
    ? "Crear"
    : state === 1
    ? t("companies:createUniversity")
    : t("companies:createCompany");

  const onSubmit = () => {
    const type = state === 1 ? "university" : "company";
    history.push(`/compañias/nueva/${type}`);
  };

  return (
    <Modal
      visible
      centered
      footer={null}
      onCancel={() => history.push("/compañias")}
      wrapProps={{
        "data-test": "universityOrCompany-modal"
      }}
    >
      <Title>Elige qué tipo de grupo deseas crear</Title>
      <Wrapper>
        <Card
          style={{
            width: "48%",
            textAlign: "center",
            borderColor: state === 1 ? "#3D64FF" : "#e8e8e8"
          }}
        >
          <img
            alt="university"
            src={university}
            style={{ marginBottom: "16px" }}
          />
          <Meta
            style={{ textAlign: "center" }}
            title="Institución académica"
            description="Tiene la propiedad de recibir vacantes de empresas privadas, y aparecerá en el listado como facultad cuando otras compañías publiquen oportunidades."
          />
          <CheckboxOverRide
            data-test="check-box-university"
            checked={state === 1}
            onChange={e => onChange(e, 1)}
          />
        </Card>
        <Card
          style={{
            width: "48%",
            textAlign: "center",
            borderColor: state === 2 ? "#3D64FF" : "#e8e8e8"
          }}
        >
          <img alt="partner" src={partner} style={{ marginBottom: "16px" }} />
          <Meta
            style={{ textAlign: "center" }}
            title="Partner"
            description="Se maneja como una empresa privada. Puede crear vacantes, pero no acepta publicaciones de terceros en su bolsa de empleo y no aparecerá listada como universidad."
          />
          <CheckboxOverRide
            data-test="check-box-partner"
            checked={state === 2}
            onChange={e => onChange(e, 2)}
          />
        </Card>
      </Wrapper>
      <ButtonSend>
        <Button
          data-test="create-universityOrCompany-btn"
          type={!state ? "ghost" : "primary"}
          disabled={!state}
          onClick={onSubmit}
          style={{ width: "100%" }}
        >
          {title}
        </Button>
      </ButtonSend>
    </Modal>
  );
};

const enhancer = compose(
  withTranslation(["global", "form", "company", "companies"])
);

export default enhancer(UniversityOrCompanyModal);
